export const TYPES = {
  DEFAULT: 'icon',
  PAYMENT: 'payment',
  ARCADE_PAYMENT: 'arcadePayment',
} as const

export const SIZES = {
  LARGE: 'Large',
  MEDIUM: 'Medium',
  SMALL: 'Small',
  EXTRA_SMALL: 'ExtraSmall',
  MINI: 'Mini',
} as const

export const VIEWBOX_MAP = {
  [TYPES.DEFAULT]: '0 0 24 24',
  [TYPES.PAYMENT]: '0 0 40 24',
  [TYPES.ARCADE_PAYMENT]: '0 0 32 32',
}

export const ROLES = {
  IMG: 'img', // meaningful, title should be read aloud to users who can't see it
  PRESENTATION: 'presentation', // decorative, should be silent to users who can't see it
} as const
